import { createSvgIcon } from '@material-ui/core';

export const Local2Icon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5328 8C14.8303 8 14.1793 8.36858 13.8178 8.97098L5.41749 22.971C5.03744 23.6044 5.03744 24.3956 5.41749 25.029L13.8178 39.029C14.1793 39.6314 14.8303 40 15.5328 40H32.4673C33.1698 40 33.8208 39.6314 34.1823 39.029L42.5826 25.029C42.9627 24.3956 42.9627 23.6044 42.5826 22.971L34.1823 8.97098C33.8208 8.36859 33.1698 8 32.4673 8H15.5328Z"
      fill="currentColor"
    />
  </svg>,
  'Local2Icon',
);
